import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plus, UserPlus, Users, ClipboardList, BellRing } from "lucide-react";
import PricingGrid from "@/components/PricingGrid";

export default function Dashboard() {
  const { user } = useAuth();

  const navPill = (to, icon, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className="inline-flex items-center gap-1.5 bg-white border border-stone-200 hover:border-stone-300 hover:shadow-sm rounded-full px-3 py-1.5 transition-all active:scale-95 whitespace-nowrap"
    >
      {icon}
      <span className="font-bold text-xs sm:text-sm">{label}</span>
    </Link>
  );

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl tracking-tight" data-testid="dashboard-greeting">
          Salut {user?.name?.split(" ")[0] || ""} 👋
        </h1>
      </div>

      {/* Navigation rapide */}
      <div className="flex gap-2 overflow-x-auto no-scrollbar -mx-1 px-1" data-testid="dashboard-quick-nav">
        {navPill("/clients", <Users className="w-4 h-4 text-stone-600" strokeWidth={2.5} />, "Clients", "quick-nav-clients")}
        {navPill("/visites", <ClipboardList className="w-4 h-4 text-stone-600" strokeWidth={2.5} />, "Visites", "quick-nav-visits")}
        {navPill("/relances", <BellRing className="w-4 h-4 text-stone-600" strokeWidth={2.5} />, "Relances", "quick-nav-relances")}
      </div>

      {/* 2 actions principales */}
      <div className="grid grid-cols-2 gap-2">
        <Link
          to="/visites/nouvelle"
          data-testid="quick-add-visit"
          className="rounded-2xl px-4 py-3 flex items-center gap-3 hover:opacity-95 transition-all shadow-md active:scale-[0.98] bg-[#9DCB2E] text-[#0f3a18]"
        >
          <div className="w-8 h-8 rounded-xl bg-white/30 grid place-items-center shrink-0">
            <Plus className="w-4 h-4" strokeWidth={3} />
          </div>
          <div className="font-heading font-black text-sm sm:text-base">
            Nouvelle visite
          </div>
        </Link>
        <Link
          to="/clients/new"
          data-testid="quick-add-client"
          className="bg-stone-900 text-white rounded-2xl px-4 py-3 flex items-center gap-3 hover:bg-stone-800 transition-all shadow-md active:scale-[0.98]"
        >
          <div className="w-8 h-8 rounded-xl bg-white/15 grid place-items-center shrink-0">
            <UserPlus className="w-4 h-4" strokeWidth={2.5} />
          </div>
          <div className="font-heading font-black text-sm sm:text-base">Nouveau client</div>
        </Link>
      </div>

      <PricingGrid user={user} />
    </div>
  );
}
